<template>
  <div class="container">
    <b-modal
      :model-value="modCrearSubmenu"
      :no-close-on-backdrop="true"
      hide-footer
            centered
      :title="labels.title"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog create-submenu-dialog"
     @hide="cierraModal">
        <div class="uniform-modal-body">
            <div class="password-policy-box mb-4">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-subtitle">{{ labels.infoText }}</div>
            </div>

            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.name }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="nombre" 
                        type="text" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="Nombre del submenú"
                    />
                </b-col>
            </b-row>

            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.description }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="descripcion" 
                        type="text" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="Descripción del submenú"
                    />
                </b-col>
            </b-row>

            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.route }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="ruta" 
                        type="text" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="/ruta-del-submenú"
                    />
                </b-col>
            </b-row>

            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.orden }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-input 
                        v-model="orden" 
                        type="number" 
                        class="form-input" 
                        autocomplete="off"
                        placeholder="Número de orden"
                    />
                </b-col>
            </b-row>

            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <label class="form-label">{{ labels.menu }}</label>
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <b-form-select 
                        v-model="menuSelected" 
                        class="form-input"
                    >
                        <option value="" disabled>Seleccione un menú</option>
                        <option
                            v-for="menu in listaMenu"
                            :key="menu.id" 
                            :value="menu.id" 
                        >
                            {{ menu?.nombre }} 
                        </option>
                    </b-form-select>
                </b-col>
            </b-row>

            <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                <b-button class="reset-btn-primary" @click="guardarSubMenu">{{ labels.save }}</b-button>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import Menu from '../../../services/Menu'; 
import SubMenu from '../../../services/SubMenu'; 

export default {
    name: "CrearSubmenu",
    props: ['modCrearSubmenu'],
    data: () => ({
        nombre: "",
        descripcion: "",
        ruta: "",
        orden: "",
        menuSelected: "",
        listaMenu: [],
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Crear submenú",
                    name: "Nombre",
                    description: "Descripción",
                    route: "Ruta",
                    menu: "Menú",
                    save: "Guardar",
                    close: "Cerrar",
                    orden: "Orden",
                    infoTitle: "Datos del submenú",
                    infoText: "Completa la información y guarda el nuevo submenú."
                }
            } else {
                return {
                    title: "Create submenu",
                    name: "Name",
                    description: "Description",
                    route: "Route",
                    menu: "Menu",
                    save: "Save",
                    close: "Close",
                    orden: "Order",
                    infoTitle: "Submenu information",
                    infoText: "Complete the information and save the new submenu."
                }
            }
        }
    },
    methods: {
        guardarSubMenu() {
            let dataForm = {
                'nombre': this.nombre,
                'descripcion': this.descripcion,
                'ruta': this.ruta,
                'orden': this.orden,
                'menu': this.menuSelected,
                'idUser': this.$store.state.userId,
            }

            if (this.nombre == "") {
                this.$toast.error('Diligenciar el campo nombre')
                return
            }
            if (this.descripcion == "") {
                this.$toast.error('Diligenciar el campo descripción')
                return
            }
            if (this.ruta == "") {
                this.$toast.error('Diligenciar el campo ruta')
                return
            }
            if (this.orden == "") {
                this.$toast.error('Diligenciar el campo orden')
                return
            }
            if (this.menuSelected == "") {
                this.$toast.error('Seleccionar un menú')
                return
            }

            SubMenu.createSubmenu(dataForm)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toast.success(res.data.message)
                        this.$emit('created')
                        this.cierraModal()
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error(err.response?.data?.message || 'Error al crear el submenú')
                })
        },
        cierraModal() {
            this.$emit('cierraModal', false)
            this.nombre = ""
            this.descripcion = ""
            this.ruta = ""
            this.orden = ""
            this.menuSelected = ""
        }
    },
    mounted() {
        Menu.getAllMenu()
            .then((res) => {
                this.listaMenu = res.data.listMenu
            })
            .catch((err) => console.log(err))
    }
}
</script>